import type { RouteRecordRaw } from 'vue-router'

// Profile 模块子页（档案 / 日记回放）
export const profileRoutes: RouteRecordRaw[] = [
  {
    path: '/profile/create-profile',
    name: 'profile-create-profile',
    component: () => import('@/pages/Profile/CreateProfile/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/profile/daily-replay',
    name: 'profile-daily-replay',
    component: () => import('@/pages/Profile/DailyReplay/index.vue'),
    meta: { backMode: 'allow' },
  },
]
